import React, { useState, useRef, useEffect } from 'react';
import { X, Check, ChevronDown } from 'lucide-react';
import { Badge } from './Badge';
import { cn } from '../../lib/utils';

export function MultiSelect({
    options = [],
    value = [],
    onChange,
    placeholder = "Seçiniz...",
    label = ""
}) {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleOption = (optionId) => {
        const newValue = value.includes(optionId)
            ? value.filter(id => id !== optionId)
            : [...value, optionId];
        onChange(newValue);
    };

    const selectedOptions = options.filter(opt => value.includes(opt.id));

    return (
        <div className="space-y-1.5" ref={containerRef}>
            {label && (
                <label className="text-xs text-gray-500 uppercase font-semibold">
                    {label}
                </label>
            )}
            <div className="relative">
                <div
                    onClick={() => setIsOpen(!isOpen)}
                    className={cn(
                        "flex min-h-[40px] w-full flex-wrap gap-1 rounded-md border border-zinc-800 bg-zinc-950 px-3 py-2 text-sm ring-offset-background cursor-pointer",
                        isOpen && "ring-2 ring-zinc-700 outline-none"
                    )}
                >
                    {selectedOptions.length > 0 ? (
                        selectedOptions.map(option => (
                            <Badge
                                key={option.id}
                                variant="secondary"
                                className="flex items-center gap-1 pr-1"
                            >
                                {option.label || option.name}
                                <X
                                    className="h-3 w-3 cursor-pointer hover:text-red-500"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleOption(option.id);
                                    }}
                                />
                            </Badge>
                        ))
                    ) : (
                        <span className="text-muted-foreground">{placeholder}</span>
                    )}
                    <ChevronDown className="ml-auto h-4 w-4 shrink-0 opacity-50" />
                </div>

                {isOpen && (
                    <div className="absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md border border-zinc-800 bg-zinc-900 py-1 shadow-xl animate-in fade-in zoom-in-95">
                        {options.length === 0 ? (
                            <div className="px-4 py-2 text-sm text-gray-500">Opsion bulunamadı.</div>
                        ) : (
                            options.map(option => {
                                const isSelected = value.includes(option.id);
                                return (
                                    <div
                                        key={option.id}
                                        onClick={() => toggleOption(option.id)}
                                        className={cn(
                                            "flex items-center justify-between px-4 py-2 text-sm cursor-pointer hover:bg-zinc-800",
                                            isSelected && "text-zinc-100 bg-zinc-800/50"
                                        )}
                                    >
                                        {option.label || option.name}
                                        {isSelected && <Check className="h-4 w-4" />}
                                    </div>
                                );
                            })
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
